import { useEffect, useCallback } from 'react';
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import RecipientCreation from '../components/RecipientCreation'
import { useState } from 'react';
import DebtCreator from '../components/DebtCreator';

export default function DebtCreation() {
    const [step, setStep] = useState(0);
    const [data, setData] = useState({
        recipient: {},
        debts: []        
    });
    const [resetTrigger, setResetTrigger] = useState(0); 


    const recipientSubmitted = useCallback((s) => {
        const newData = {...data, recipient: s};
        setData(newData);
        setStep(1);
        localStorage.setItem('debtCreationData', JSON.stringify(newData));
        localStorage.setItem('debtCreationStep', '1');
    }, [data]);

    useEffect(() => {
        const savedData = localStorage.getItem('debtCreationData');
        const savedStep = localStorage.getItem('debtCreationStep');
        if (savedData && savedStep) {
            setData(JSON.parse(savedData));
            setStep(parseInt(savedStep));
        }
    }, []);

    const back = useCallback((s) => {
        const newData = {...data, debts: s};
        setData(newData);
        setStep(0);
        localStorage.setItem('debtCreationData', JSON.stringify(newData));
        localStorage.setItem('debtCreationStep', '0');
    }, [data]);

    const resetAll = () => {
        const newData = { recipient: {}, debts: [] };
        localStorage.setItem('debtCreationData', JSON.stringify(newData));
        localStorage.setItem('debts', JSON.stringify([]));
        localStorage.setItem('debtCreationStep', '0');
        setData(newData);
        setStep(0); 
        setResetTrigger(prev => prev + 1); // trigger RecipientCreation to reload
    };

    return (
        <div>        
            <div className='relative mx-auto w-full max-w-container px-4 sm:px-6 lg:px-8'>
                {step === 0 && <RecipientCreation notifyParent={recipientSubmitted} resetTrigger={resetAll} />}
                {step === 1 && <DebtCreator notifyParent={back} resetTrigger={resetAll} />}
        </div>
        </div>

    );
}
